import AddIcon from '@mui/icons-material/Add';
import React, { useEffect, useState } from 'react';

import { PartTypeList } from './PartTypeList';
import { ActionPermissions, CustomPermission } from '../../@types';
import { Button, ButtonVariantProps } from '../../components/atoms/Button';
import { HorizontalAlignProps, InlineGroup } from '../../components/atoms/InlineGroup';
import { Link } from '../../components/atoms/Link';
import { PageContainer } from '../../components/atoms/PageContainer';
import { Typography, TypographyVariantProps } from '../../components/atoms/Typography';
import { PLATFORM_NAME } from '../../configs/common';
import { isUserHasPermission } from '../../configs/permissions';
import { TabHandler } from '../../handlers/TabHandler';
import { useGetUserSystemPermissions } from '../../queries/user-query';
import { Wrapper } from '../../styled/common.styles';

export const PartTypes: React.FC = () => {
  const [permissions, setPermissions] = useState<CustomPermission[]>();
  const getUserPermissionsQuery = useGetUserSystemPermissions();

  useEffect(() => {
    getUserPermissionsQuery.data && setPermissions(getUserPermissionsQuery.data);
  }, [getUserPermissionsQuery.data]);

  TabHandler(`List Part Types | ${PLATFORM_NAME}`);

  return (
    <PageContainer>
      <Wrapper>
        <InlineGroup horizontal={HorizontalAlignProps.Between}>
          <Typography variant={TypographyVariantProps.H5} fontWeight={600}>
            List Part Types
          </Typography>
          {isUserHasPermission(ActionPermissions.Configure_Part_Type_Create, permissions) && (
            <Link href="configure/partTypes/create">
              <Button variant={ButtonVariantProps.Primary} startIcon={<AddIcon />}>
                ADD Part Type
              </Button>
            </Link>
          )}
        </InlineGroup>
        <PartTypeList />
      </Wrapper>
    </PageContainer>
  );
};
